import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import InstructionAudioFormContainer from './InstructionAudioFormContainer';

const InstructionAudioFormScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Instruction Audios',
          link: '/instruction-audios',
        },
        {
          text: props.params.instructionAudioId ? 'Edit Instruction Audio' : 'Add Instruction Audio',
        },
      ]}
    />
    <Card
      title={props.params.instructionAudioId ? 'Edit Instruction Audio' : 'Add Instruction Audio'}
      actions={<Button type="default" icon="arrow-left" label="Back" onClick={() => browserHistory.goBack()} />}
    >
      <InstructionAudioFormContainer instructionAudioId={props.params.instructionAudioId} />
    </Card>
  </div>
);

InstructionAudioFormScene.propTypes = {
  params: PropTypes.shape({
    instructionAudioId: PropTypes.string,
  }),
};

InstructionAudioFormScene.defaultProps = {
  params: null,
};

export default InstructionAudioFormScene;
